import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AppLoaderService } from "app/core/services/app-loader/app-loader.service";
import { ChangeDetectorRef } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Paging } from "app/views/calibrations/shared/components/paging";
import { DealService } from "app/api/services";
import { EnumViewModel, MarinePartDto } from "app/api/models";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { getUniqueOnSelf } from "app/app.component";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { AppAuthService } from "app/api/services/cookie-jwt-auth/app-auth.service";
import { CommonModule } from "@angular/common";
import { SharedModule } from "app/core/shared.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatOptionModule } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { AddItemDialogComponent } from "app/core/components/add-item-dialog/add-item-dialog.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

@Component({
  selector: "app-marine-part-register-list",
  templateUrl: "./marine-part-register-list.component.html",
  styleUrls: ['./marine-part-register-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    // RouterLink,
    MatTooltipModule,
    // MatRippleModule,
    // MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    // MatDatepickerModule,
    // TextFieldModule,
    // FuseFindByKeyPipe,
    // DatePipe,
    MatSlideToggleModule,
    // MatAutocompleteModule,
    MatPaginatorModule,
    // SharedComponentsModule,
    // MatTabsModule,
  ],
})
export class MarinePartRegisterListComponent extends Paging implements OnInit {
  public marineParts: MarinePartDto[];
  public showArchived: boolean = false;
  public selectedCategory: string = null;
  public selectedSupplier: string = null;
  
  public categories: string[];
  public suppliers: string[];

  public isAdmin: boolean = false;

  constructor(
    private dealService: DealService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private cdr: ChangeDetectorRef,
    private _fuseConfirmationService: FuseConfirmationService,
    private appAuth: AppAuthService,
  ) {
    super();
  }

  ngOnInit() {
    this.isAdmin = this.appAuth.isAdmin();
    this.load();
  }

  override load() {
    this.loader.open();

    this.dealService.apiDealMarinePartsGet$Json({ searchTerm: this.searchTerm, archived: this.showArchived }).subscribe(res => {
      if(!res?.data) return;

      this.categories = getUniqueOnSelf(res.data.map(x => x.category).filter(x => !!x));
      this.suppliers = getUniqueOnSelf(res.data.map(x => x.supplier).filter(x => !!x));

      if(this.selectedCategory)
        res.data = res.data.filter(x => x.category.toLowerCase() == this.selectedCategory.toLowerCase());
      
      if(this.selectedSupplier)
        res.data = res.data.filter(x => x.supplier.toLowerCase() == this.selectedSupplier.toLowerCase());

        this.setPageInfoFromManualRes(res.data);
        this.marineParts = this.getManualPagedItems(res.data);
        this.loader.close();
        this.cdr.detectChanges();
      });
  }

  archiveMarinePart(marinePart: MarinePartDto, archive: boolean = true) {
    event.stopPropagation();
      if(!marinePart) return;
  
      var title = this.showArchived ? "Restore Marine Part" : "Archive Marine Part";
      var message = this.showArchived ? "restore" : "remove";

      // Open the confirmation dialog
      const confirmation = this._fuseConfirmationService.open({
        title  : title,
        message: 'Are you sure you want to ' + message + ' this part?',
        actions: {
            confirm: {
              label: this.showArchived ? "Restore" : "Archive",
            },
        },
      });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.dealService.apiDealArchiveMarinePartDelete$Json$Response({marinePartId: marinePart.marinePartId, archive: archive}).subscribe(res => {
          if(!res?.body?.data) return;
          this.load();
        });
      }
    });
  }

  search(event: any) {
    this.searchTerm = event?.target?.value;
    this.page.pageIndex = 0;
    this.load();
  }

  selectedCategoryChanged(event: MatSelectChange) {
    this.selectedCategory = event?.value;
    this.load();
  }
  selectedSupplierChanged(event: MatSelectChange) {
    this.selectedSupplier = event?.value;
    this.load();
  }

  toggleArchive(e: MatCheckboxChange) {
    this.showArchived = e.checked;
    this.load();
  }

  openMarinePartDetails(currentValue: MarinePartDto = null) {
      //open it up
      var dialog = this.dialog.open(AddItemDialogComponent, {
        data: {
              title: `${currentValue ? 'Edit' : 'Add'} Marine Part`,
              items: [
                  {name: 'part Name', propertyName: 'partName', initialValue: currentValue?.partName ?? '', mandatory: true},
                  {name: 'supplier', type: 'autocomplete', options: this.suppliers.map((x,i) => <EnumViewModel>{name: x, value: i}), initialValue: currentValue?.supplier ?? '', mandatory: true},
                  {name: 'category', type: 'autocomplete', options: this.categories.map((x,i) => <EnumViewModel>{name: x, value: i}), initialValue: currentValue?.category ?? ''},
                  {name: 'cost', type: 'currency', initialValue: currentValue?.cost ?? 0},
                  {name: 'price', type: 'currency', initialValue: currentValue?.price ?? 0},
              ],
          }
      });
  }
  
  //inline edit
  UpdateItem(event: any, property: string, item: MarinePartDto) {
    var value: string = event.target?.value ?? event.value;

    if(property == 'cost' || property == 'price')
      value = value.replace(',', '');

    item[property] = value;

    this.dealService.apiDealUpdateMarinePartPut$Json$Response({body: item}).subscribe(res => {
        if(!res?.body?.data) return;
    });
  }
}
